import Vue from 'vue';
import VueRouter from 'vue-router';
import Testing from '@/views/Testing.vue';
import TodoDetail from '@/views/todo-detail/index.vue';
import TodoDetailNew from '@/views/todo-detail/index-new.vue';
import TodoTmp from '@/views/todo-tmp.vue';
import TodoTmpOld from '@/views/todo-tmp-old.vue';
import Done from '@/views/done.vue';
import DoneOld from '@/views/done-old.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/todo',
  },
  {
    path: '/todo',
    name: '待办',
    meta: {
      title: '我的待办',
    },
    component: TodoTmpOld,
  },
  {
    path: '/todo-new',
    name: '待办新版',
    meta: {
      title: '我的待办',
    },
    component: TodoTmp,
  },
  {
    path: '/todo-detail',
    name: '待办详情',
    component: TodoDetail,
    beforeEnter(to, from, next) {
      document.title = to?.query?.isHistory ? '已办详情 - 腾讯工单' : '待办详情 - 腾讯工单';
      next();
    },
  },
  {
    path: '/todo-detail-new',
    name: '待办详情新版',
    component: TodoDetailNew,
    beforeEnter(to, from, next) {
      document.title = to?.query?.isHistory ? '已办详情 - 腾讯工单' : '待办详情 - 腾讯工单';
      next();
    },
  },
  {
    path: '/test-page',
    name: '测试页面',
    component: Testing,
  },

  {
    path: '/move-check',
    name: '搬迁-主管验收确认',
    component: () => import('@/views/todo-details-paeg/Move/move-check.vue'),
  },
  {
    path: '/move-outin',
    name: '搬迁-出入库',
    component: () => import('@/views/todo-details-paeg/Move/move-outin.vue'),
  },
  {
    path: '/move-with',
    name: '搬迁-上下架随工',
    component: () => import('@/views/todo-details-paeg/Move/move-with.vue'),
  },
  {
    path: '/move-updown',
    name: '搬迁-上下架',
    component: () => import('@/views/todo-details-paeg/Move/move-updown.vue'),
  },
  {
    path: '/common',
    name: '待办-通用工单',
    component: () => import('@/views/todo-details-paeg/Common/common.vue'),
  },
  {
    path: '/asset_out',
    name: '待办-备件出库',
    component: () => import('@/views/todo-details-paeg/Asset/asset_out.vue'),
  },

  {
    path: '/finished',
    name: '已完成',
    component: DoneOld,
    meta: {
      title: '我的已办',
    },
  },
  {
    path: '/finished-new',
    name: '已完成新版',
    component: Done,
    meta: {
      title: '我的已办',
    },
  },

  {
    path: '/signature',
    name: '电子签名',
    component: () => import('@/components/signature.vue'),
  },

  {
    path: '/fins-move-check',
    name: '已完成-搬迁-主管验收确认',
    component: () => import('@/views/finished-details-page/fin-Move/fins-move-check.vue'),
  },
  {
    path: '/fins-move-outin',
    name: '已完成-搬迁-出入库',
    component: () => import('@/views/finished-details-page/fin-Move/fins-move-outin.vue'),
  },
  {
    path: '/fins-move-with',
    name: '已完成-搬迁-上下架随工',
    component: () => import('@/views/finished-details-page/fin-Move/fins-move-with.vue'),
  },
  {
    path: '/fins-move-updown',
    name: '已完成-搬迁-上下架',
    component: () => import('@/views/finished-details-page/fin-Move/fins-move-updown.vue'),
  },
  {
    path: '/fins-common',
    name: '',
    component: () => import('@/views/finished-details-page/fin-common/fins-common.vue'),
  },
  {
    path: '/fins-asset_out',
    name: '已办-备件出库',
    component: () => import('@/views/finished-details-page/fin-Asset/fins-asset_out.vue'),
  },

  // 退役路由   暂无已完成页面
  {
    path: '/retire-block',
    name: '退役拔线/封箱',
    component: () => import('@/views/todo-details-paeg/Retire/retire-block.vue'),
  },
  {
    path: '/retire-check',
    name: '退役随工检查',
    component: () => import('@/views/todo-details-paeg/Retire/retire-check.vue'),
  },
  {
    path: '/retire-ssd',
    name: '退役拔盘',
    component: () => import('@/views/todo-details-paeg/Retire/retire-ssd.vue'),
  },
  {
    path: '/retire-enter',
    name: '退役入库',
    component: () => import('@/views/todo-details-paeg/Retire/retire-enter.vue'),
  },
  {
    path: '/upload',
    name: '文件上传',
    component: () => import('@/components/uploadNew.vue'),
  },
  {
    path: '/camera',
    name: '企业微信扫一扫',
    component: () => import('@/components/camera.vue'),
  },
  {
    path: '/location',
    name: '企业微信定位',
    component: () => import('@/components/Formily/Contact.vue'),
  },
  {
    path: '/handle',
    name: '企业微信定位',
    component: () => import('@/views/Handle.vue'),
  },
  {
    path: '/retireShowTest',
    name: '退役文字展示',
    component: () => import('@/components/commonShowData/retireShowTest.vue'),
  },
  {
    path: '/loading/:appid?',
    name: 'loading',
    component: () => import('@/views/Loading.vue'),
  },
  {
    // 自动化变更进展页处理跳转至tencent域名下
    path: '/autoManage/workbench/execute/progress',
    name: 'autoExecuteProgress',
    component: () => import('@/views/auto/execute-progress.vue'),
  },
  {
    path: '/CommonModule',
    name: '通用工单',
    component: () => import('@/components/CommonModule.vue'),
  },
  {
    path: '/testPage',
    name: 'test',
    component: () => import('@/components/testPage.vue'),
  },
  {
    path: '/overview',
    name: '总览页',
    component: () => import('@/views/overView/overview.vue'),
  },

  {
    path: '/retirePN',
    name: 'PN搜索',
    component: () => import('@/components/retirePN.vue'),
  },
  {
    path: '/search',
    name: '模糊查询',
    component: () => import('@/components/search.vue'),
  },
  // 机房裁撤
  {
    path: '/dissolve-evaluated',
    name: '机架裁撤评估单',
    component: () => import('@/views/todo-details-paeg/dissolve/dissolve-evaluated.vue'),
  },
  {
    path: '/dissolve-cut-cable',
    name: '机架裁撤拆线操作单',
    component: () => import('@/views/todo-details-paeg/dissolve/dissolve-cut-cable'),
  },
  // 维修部件
  {
    path: '/repair-components',
    name: '维修部件工单查询',
    component: () =>
      import('@/views/todo-details-paeg/repair-components/Queryassetwork/repair-components'),
  },
  {
    path: '/repair-components-detail',
    name: '维修部件工单详情',
    component: () =>
      import('@/views/todo-details-paeg/repair-components/Queryassetwork/repair-components-detail'),
  },
  // 现场派单服务台
  {
    path: '/serviceCounter',
    name: '现场派单服务台',
    meta: {
      title: '现场派单服务台',
    },
    component: () => import('@/views/todo-details-paeg/serviceCounter/home'),
  },
  // 搬迁接线上报
  {
    path: '/moveReport',
    name: '搬迁接线上报',
    component: () => import('@/views/todo-details-paeg/moveReport/moveReport'),
  },
  {
    path: '/technicalSupport',
    name: '服务器技术申请',
    component: () => import('@/views/todo-details-paeg/serviceCounter/components/technicalSupport'),
  },
  {
    path: '/specializedForCables',
    name: '服务器一分二线缆授权专用',
    component: () =>
      import('@/views/todo-details-paeg/serviceCounter/components/specializedForCables'),
    meta: { title: '服务器一分二线缆授权专用' },
    hidden: true,
  },
  {
    path: '/haltrequest',
    name: '服务器授权停机申请',
    component: () => import('@/views/todo-details-paeg/serviceCounter/components/haltrequest'),
  },
  {
    path: '/commonConsult',
    name: '通用查询',
    component: () => import('@/views/todo-details-paeg/serviceCounter/components/commonConsult'),
  },
  {
    path: '/queryDealer',
    name: '处理人查询',
    meta: {
      title: '处理人查询',
    },
    component: () => import('@/views/todo-details-paeg/serviceCounter/components/queryDealer'),
  },
  {
    path: '/queryAsset',
    name: '网络工单查询',
    meta: {
      title: '网络工单查询',
    },
    component: () => import('@/views/todo-details-paeg/serviceCounter/components/queryAsset'),
  },
  {
    path: '/osVersionDownload',
    name: '网络OS版本下载',
    meta: {
      title: '网络OS版本下载',
    },
    component: () =>
      import('@/views/todo-details-paeg/serviceCounter/components/osVersionDownload'),
  },

  // 设备管理工具
  {
    path: '/managementTool',
    name: '设备管理工具',
    meta: {
      title: '设备管理工具',
    },
    component: () => import('@/views/todo-details-paeg/equipmentManagement/home'),
  },
  {
    path: '/deviceDetails',
    name: '设备详情信息',
    meta: {
      title: '设备详情信息',
      DeviceCategoryID: '',
    },
    component: () =>
      import('@/views/todo-details-paeg/equipmentManagement/components/deviceDetails'),
  },
  {
    path: '/model360',
    name: '设备模型',
    meta: {
      title: '设备模型',
      DeviceCategoryID: '',
    },
    component: () => import('@/views/todo-details-paeg/equipmentManagement/components/model360'),
  },
  {
    path: '/otherTools',
    name: '其他工具',
    meta: {
      title: '其他工具',
    },
    component: () => import('@/views/todo-details-paeg/equipmentManagement/components/otherTools'),
  },
  {
    path: '/numberDetails',
    name: '通过编号查看设备详情',
    meta: {
      title: '通过编号查看设备详情',
    },
    component: () =>
      import('@/views/todo-details-paeg/equipmentManagement/components/numberDetails'),
  },
  {
    path: '/labelVerification',
    name: '设备扫码拍照核验',
    meta: {
      title: '设备扫码拍照核验',
    },
    component: () =>
      import('@/views/todo-details-paeg/equipmentManagement/components/labelVerification'),
  },
  {
    path: '/successfulVerification',
    name: '核验成功',
    meta: {
      title: '核验成功',
    },
    component: () =>
      import('@/views/todo-details-paeg/equipmentManagement/components/successfulVerification'),
  },
  {
    path: '/measurePointTestMobile',
    name: '测试任务(移动端)',
    meta: { title: '测试任务(移动端)' },
    component: () =>
      import('@/views/todo-details-paeg/verificationTestManage/measurePointTestMobile/index'),
  },
  //
  {
    path: '/l5testDetails',
    name: 'l5testDetails',
    meta: { title: 'l5测试详情', icon: 'el-icon-set-up' },
    component: () =>
      import(
        '@/views/todo-details-paeg/verificationTestManage/measurePointTestMobile/l5testDetails'
      ),
  },
  {
    path: '/testDetails',
    name: 'testDetails',
    meta: { title: '测试详情', icon: 'el-icon-set-up' },
    component: () =>
      import('@/views/todo-details-paeg/verificationTestManage/measurePointTestMobile/testDetails'),
  },
  // {
  //   path: '/testDetails2', name: 'testDetails2', meta: { title: '测试详情', icon: 'el-icon-set-up' },
  //   component: () => import('@/views/todo-details-paeg/verificationTestManage/measurePointTestMobile/testDetails2'),
  // },
  // {
  //   path: '/l6_details', name: 'l6_details', meta: { title: '测试详情', icon: 'el-icon-set-up' },
  //   component: () => import('@/views/todo-details-paeg/verificationTestManage/measurePointTestMobile/l6_details'),
  // },
  //
  {
    path: '/operationsTools',
    name: '诊断工具',
    component: () => import('@/views/itOperation/ServerManagement'),
  },
  {
    path: '/related-wework',
    name: '关联企业微信',
    meta: {
      title: '关联Dcosp工单',
    },
    component: () => import('@/views/related-wework/related_ot.vue'),
  },
  // 建设平台
  {
    path: '/constructionPlatform',
    name: '建设平台',
    component: () => import('@/views/todo-details-paeg/constructionPlatform/home/home'),
  },
  {
    path: '/constructionProblem',
    name: '建设问题',
    component: () =>
      import('@/views/todo-details-paeg/constructionPlatform/constructionProblem/home'),
  },
  {
    path: '/testProblem',
    name: '测试问题',
    component: () => import('@/views/todo-details-paeg/constructionPlatform/testProblem/home'),
  },
  {
    path: '/operationMaintenanceProblem',
    name: '运维问题',
    component: () =>
      import('@/views/todo-details-paeg/constructionPlatform/operationMaintenanceProblem/home'),
  },
  {
    path: '/onSiteVerification',
    name: '设备现场确认核验',
    meta: {
      title: '设备现场确认核验',
    },
    component: () =>
      import('@/views/todo-details-paeg/equipmentManagement/components/onSiteVerification'),
  },
  {
    path: '/numberingLocation',
    name: '展示编号定位核验',
    meta: {
      title: '展示编号定位核验',
    },
    component: () =>
      import('@/views/todo-details-paeg/equipmentManagement/components/numberingLocation'),
  },
  {
    path: '/useTutorial',
    name: '收集核验工具使用教程',
    meta: {
      title: '收集核验工具使用教程',
    },
    component: () => import('@/views/todo-details-paeg/equipmentManagement/components/useTutorial'),
  },
  {
    path: '/assetTransferToPoTool',
    name: '转PO工具',
    meta: {
      title: '转PO工具',
    },
    component: () => import('@/views/todo-details-paeg/assetTransferToPoTool/index'),
  },
  {
    path: '/idcManager/mobile/regionBoard',
    name: '区域看板',
    meta: {
      title: '区域看板',
    },
    component: () => import('@/views/eop/regionBoard/index.vue'),
  },
  {
    path: '/idcManager/mobile/parkBoard',
    name: '合建园区看板',
    meta: {
      title: '合建园区看板',
    },
    component: () => import('@/views/eop/parkBoard/index.vue'),
  },
  {
    path: '/idcManager/mobile/eopView',
    name: '自建园区看板',
    meta: {
      title: 'eopView',
    },
    component: () => import('@/views/eop/eopView/index.vue'),
  },
  {
    name: 'change-simulation-sop',
    path: '/change/simulation/sop',
    component: () => import('@/views/change/simulation/sop'),
    meta: {
      title: 'SOP方案',
    },
  },
  {
    name: 'change-simulation-sop-detail',
    path: '/change/simulation/sop-detail',
    component: () => import('@/views/change/simulation/sop_detail'),
    meta: {
      title: 'SOP方案详情',
    },
  },
  // 网络部件扫码查询
  {
    path: '/networkScan',
    name: 'networkScan',
    meta: {
      title: '网络部件扫码查询',
    },
    component: () => import('@/views/network/networkScan/index.vue'),
  },
  // 网络技术升级
  {
    path: '/networkUpgrade',
    name: 'networkUpgrade',
    meta: {
      title: '网络技术升级',
    },
    component: () => import('@/views/network/networkUpgrade/index.vue'),
  },
  // 网络转单处理
  {
    path: '/networkWorkOrder',
    name: 'networkWorkOrder',
    meta: {
      title: '网络转单处理',
    },
    component: () => import('@/views/network/networkWorkOrder/index.vue'),
  },
  // 有效风险识别建单
  {
    path: '/riskManagement',
    name: 'riskManagement',
    meta: {
      title: '有效风险识别建单',
    },
    component: () => import('@/views/riskManagement/index.vue'),
  },
  {
    path: '/serviceProvider',
    name: 'serviceProvider',
    meta: {
      title: '服务商商务录入人员资质',
    },
    component: () => import('@/views/serviceProvider/index.vue'),
  },
  {
    path: '/mesConsoleLaunch',
    name: 'mesConsoleLaunch',
    meta: {
      title: 'MES上架',
    },
    component: () =>
      import('@/views/environmentallyFactory/businessTransformation/console/index.vue'),
  },
  {
    path: '/reformList',
    name: 'reformList',
    meta: {
      title: '改造工单',
    },
    component: () =>
      import('@/views/environmentallyFactory/businessTransformation/reformList/index.vue'),
  },
  {
    path: '/reformScan',
    name: 'reformScan',
    meta: {
      title: '改造工单扫描',
    },
    component: () =>
      import('@/views/environmentallyFactory/businessTransformation/reformScan/index.vue'),
  },
  {
    path: '/maintainDetails',
    name: 'maintainDetails',
    meta: {
      title: '维护设备异常详情',
    },
    component: () => import('@/views/maintainDetails/index.vue'),
  },
  {
    path: '/connectWith',
    name: 'connectWith',
    meta: {
      title: '接维查验单',
    },
    component: () => import('@/views/connectWith/index.vue'),
  },
  {
    path: '/trainManage/examManage',
    name: 'examEntry',
    meta: { title: '我的考试' },
    component: () => import('@/views/trainManage/examManage/examEntry.vue'),
  },
  {
    path: '/trainManage/examManage/answer',
    name: 'examManageAnswer',
    meta: { title: '在线答题' },
    component: () => import('@/views/trainManage/examManage/answer.vue'),
  },
  {
    path: '/trainManage/examManage/score',
    name: 'examManageScore',
    meta: { title: '考试成绩' },
    component: () => import('@/views/trainManage/examManage/score.vue'),
  },
];
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

// 全局路由守卫：处理灰度逻辑
router.beforeEach((to, from, next) => {
  // 处理 /todo 和 /finished 路由的灰度逻辑：白名单内用户使用旧版，其余默认使用新版
  if (to.path === '/todo' || to.path === '/finished') {
    try {
      const store = require('@/store').default;
      const todoUiGrayList = JSON.parse(store.getters.getConfigItem('todoUiGrayList') || '[]');
      const userid = sessionStorage.getItem('userid');
      const isInGrayList =
        userid && Array.isArray(todoUiGrayList) && todoUiGrayList.includes(userid);

      // 不在白名单中：跳转到新版
      if (!isInGrayList) {
        const newPath = to.path === '/todo' ? '/todo-new' : '/finished-new';
        return next({
          path: newPath,
          query: to.query,
          replace: true,
        });
      }
      // 在白名单中：继续使用旧版，上报aegis日志
      const { aegis } = store.state.user;
      if (aegis) {
        aegis.infoAll({
          msg: JSON.stringify({
            type: 'todo-list-not-redirect',
            reason: 'user_in_whitelist',
            path: to.path,
            userid,
            query: to.query,
          }),
          ext1: 'todo-list-no-redirect',
          ext2: 'in_whitelist',
        });
      }
    } catch (e) {
      console.error('[Router] 待办/已办灰度逻辑异常:', e);
      // 异常时默认跳转到新版
      const newPath = to.path === '/todo' ? '/todo-new' : '/finished-new';
      return next({
        path: newPath,
        query: to.query,
        replace: true,
      });
    }
  }

  // 处理 /todo-detail 路由的灰度逻辑
  if (to.path === '/todo-detail') {
    try {
      const store = require('@/store').default;
      const detailUiGrayList = JSON.parse(store.getters.getConfigItem('detailUiGrayList') || '[]');
      const userid = sessionStorage.getItem('userid');

      // 灰度名单为空数组，全量使用新版
      if (userid && detailUiGrayList?.length === 0) {
        return next({
          path: '/todo-detail-new',
          query: to.query,
          // replace: true
        });
      }

      // 用户在灰度名单中，根据本地存储决定版本
      if (userid && detailUiGrayList?.length > 0 && detailUiGrayList.includes(userid)) {
        const useNew = localStorage.getItem('todoDetailVersionNew') !== 'false';
        if (useNew) {
          return next({
            path: '/todo-detail-new',
            query: to.query,
            // replace: true
          });
        }
        // 用户在灰度名单中但本地存储选择了旧版，上报aegis日志
        const { aegis } = store.state.user;
        if (aegis) {
          aegis.infoAll({
            msg: JSON.stringify({
              type: 'todo-detail-not-redirect',
              reason: 'user_in_graylist_but_localStorage_false',
              userid,
              detailUiGrayList,
              todoDetailVersionNew: localStorage.getItem('todoDetailVersionNew'),
              query: to.query,
            }),
            ext1: 'todo-detail-no-redirect',
            ext2: 'localStorage_false',
          });
        }
      } else {
        // 用户不在灰度名单中，使用旧版，上报aegis日志
        const { aegis } = store.state.user;
        if (aegis) {
          aegis.infoAll({
            msg: JSON.stringify({
              type: 'todo-detail-not-redirect',
              reason: 'user_not_in_graylist',
              userid,
              detailUiGrayListLength: detailUiGrayList?.length,
              query: to.query,
            }),
            ext1: 'todo-detail-no-redirect',
            ext2: 'not_in_graylist',
          });
        }
      }

      // 其他情况使用旧版（已经在 /todo-detail 路径）
      next();
    } catch (e) {
      console.error('[Router] 待办详情灰度逻辑异常:', e);
      // 异常时上报aegis日志
      try {
        const store = require('@/store').default;
        const { aegis } = store.state.user;
        if (aegis) {
          aegis.infoAll({
            msg: JSON.stringify({
              type: 'todo-detail-not-redirect',
              reason: 'exception',
              error: e?.message || String(e),
              userid: sessionStorage.getItem('userid'),
              query: to.query,
            }),
            ext1: 'todo-detail-no-redirect',
            ext2: 'exception',
          });
        }
      } catch (_) {}
      // 解析失败时走默认旧版
      next();
    }
  } else {
    next();
  }
});

export default router;
